import { RoleCode } from "features/RolesAndPermissions/constants/role.constants";
import type { User } from "features/Users/types/user.types";
import type { WorkOrder } from "features/WorkOrders/types/work-order.types";
import {
  WorkOrderStatus,
  workOrderAllowsLineItemUpdate,
  workOrderAllowsRecordUpdate,
} from "features/WorkOrders/constants/work-order.constants";

function normalizedRoleCodes(user: User | null | undefined): string[] {
  return (user?.roles ?? []).map((r: { code: string }) => String(r.code).toLowerCase());
}

export function isAdminOrSuper(
  user: User | null | undefined,
  isSuperAdmin: boolean,
): boolean {
  if (isSuperAdmin) return true;
  const codes = normalizedRoleCodes(user);
  return codes.includes(RoleCode.SUPER_ADMIN);
}

export function workOrderPermissionFlags(
  user: User | null | undefined,
  workOrder: WorkOrder | null | undefined,
  isSuperAdmin: boolean,
) {
  const admin = isAdminOrSuper(user, isSuperAdmin);
  // Once completed, only a Super Admin may still edit the record — including
  // its line items, which would otherwise stay open post-completion for
  // anyone with update permission.
  const isCompleted = workOrder?.status === WorkOrderStatus.COMPLETED;
  const canEdit = isCompleted
    ? admin
    : workOrderAllowsRecordUpdate(workOrder?.status);
  const canEditLineItems = isCompleted
    ? admin
    : workOrderAllowsLineItemUpdate(workOrder?.status);
  return {
    canEdit,
    canEditLineItems,
    isAdmin: admin,
  };
}
